import apiClient from './apiConfig';

class PaymentService {
  // Create payment session (legacy)
  async createSession(sessionData) {
    try {
      const response = await apiClient.post('/payment/session', sessionData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create payment session');
    }
  }

  // Process payment (legacy)
  async processPayment(paymentData) {
    try {
      const response = await apiClient.post('/payment/payment', paymentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Payment processing failed');
    }
  }

  // Get payment status (legacy)
  async getPaymentStatus(paymentId) {
    try {
      const response = await apiClient.get(`/payment/payment/${paymentId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to get payment status');
    }
  }

  // Hosted Checkout Methods
  // Create hosted checkout session
  async createHostedCheckout(checkoutData) {
    try {
      const response = await apiClient.post('/hosted-checkout/create', checkoutData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create hosted checkout');
    }
  }

  // Get hosted checkout status
  async getHostedCheckoutStatus(hostedCheckoutId) {
    try {
      const response = await apiClient.get(`/hosted-checkout/status/${hostedCheckoutId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to get hosted checkout status');
    }
  }

  // Cancel hosted checkout
  async cancelHostedCheckout(hostedCheckoutId) {
    try {
      const response = await apiClient.delete(`/hosted-checkout/${hostedCheckoutId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to cancel hosted checkout');
    }
  }
}

export const paymentService = new PaymentService();
